import {PaymentOnTrial, PaymentRegistered, PaymentSucceeded, PaymentUnregistered} from '../../app';
 
export default class menuController {
  constructor($state, AuthService, $window, LoginService, $uibModal, ContentService, Notification, moment, $validation, ProfilePermissionsService, $translate, amMoment, SubscriptionService, AccountInformationService) {
    this.state = $state;
    this.AuthService = AuthService;
    this.$window = $window;
    this.LoginService = LoginService;
    this.modal = $uibModal;
    this.service = ContentService;
    this.notify = Notification;
    this.moment = moment;
    this.permissionsService = ProfilePermissionsService;
    this.trans = $translate;
    this.am = amMoment;
    this.suscriptionService = SubscriptionService;
    this.accountService = AccountInformationService;
  }

  $onInit() {
    this.subscriptions = [];

    this.actualDate = this.moment();

    this.subscriptions.push(
      this.LoginService.getUserProfiles().subscribe((profiles) => {
        this.profiles = profiles;
        this.currentProfile = profiles.find(
          (p) => p.account_id === this.AuthService.parseJwt(this.AuthService.getAccountToken()).id
        );
        this.userLanguage = this.$window.localStorage.userLanguage || this.currentProfile.language;
      })
    );
    this.invitationsPending = [];
    this.subscriptions.push(
      this.service.checkInvitations().subscribe(
        resp => this.invitationsPending = resp.invitations,
        resp => this.invitationsPending = []
      )
    );

    this.subscriptions.push(
      this.suscriptionService.paymentStatus()
        .subscribe(status => {
          this.isPaymentPending = ![PaymentOnTrial, PaymentRegistered, PaymentSucceeded]
            .includes(status)
          this.isOnTrial = PaymentOnTrial === status;
          this.trialPeriodEnding = this.$window.localStorage.trialPeriodEnding;

          if (this.isPaymentPending) {
            if (this.permissionsService.hasPermission('manage-subscription')) {
                this.state.go(
                  status === PaymentUnregistered ? 'accountSubscription' : 'accountInformation',
                  { activeTab: 3 }
                );
            } else {
                this.$window.localStorage.removeItem('accToken');
                this.$window.localStorage.removeItem('accPayStatus');
                this.$window.localStorage.removeItem('currentProfile');

                this.state.go('paymentNotice');
            }
          } else if (this.isOnTrial && !this.suscriptionService.wasGraceNoticeDisplayed()) {
            this.openGracePeriodEndModel();
            this.suscriptionService.setGraceNoticeDisplayed();
          }
        })
    );
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.service.stopCheckingInvitations();
  }

  logout(){
    this.subscriptions.push(
      this.AuthService.logout().subscribe(
        (data) => {
          this.$window.localStorage.removeItem('jwtToken');
          this.$window.localStorage.removeItem('accToken');
          this.$window.localStorage.removeItem('userLanguage');
          this.state.go('login');
        }
      )
    );
  }

  openGracePeriodEndModel() {
    var that = this;
    this.modal.open({
      animation: true,
      size: 'md',
      templateUrl: 'grace-period-end-notice-template.html',
      appendClassName: 'ngdialog-theme-plain',
      controller: ($scope, $state, $uibModalInstance) => {
        "ngInject";
        $scope.canPaySubscription = that.permissionsService.hasPermission('manage-subscription');
        $scope.trialPeriodEnding = that.trialPeriodEnding;
        $scope.navigateToPayments = () => {
          that.state.go('accountInformation', {
            activeTab: 3
          });
          $uibModalInstance.close()
        };
      }
    });
  }

  openModalClosingHour(){
    var that = this;
    this.modal.open({
      animation: true,
      size: 'lg',
      templateUrl: 'closing-hour-template.html',
      appendClassName: 'ngdialog-theme-plain',
      controller: ($scope, $state, $uibModalInstance) => {
        "ngInject";
        that.subscriptions.push(
          that.service.getClosingHour().subscribe((hour) => $scope.hour = hour || "01:00")
        );
        $scope.closeThisDialog = () => $uibModalInstance.close();
        $scope.updateHour = () => {
          that.subscriptions.push(
            that.service.updateClosingHour($scope.hour).subscribe(
              (resp) => {
                that.notify.success('El horario de ciere ha sido actualizado exitosamente.!');
                $scope.closeThisDialog();
              }
            )
          );
        };
      }
    });
  }

  openModalInviteUser(){
    var that = this;
    this.modal.open({
      animation: true,
      size: 'lg',
      templateUrl: 'invite-user-template.html',
      appendClassName: 'ngdialog-theme-plain',
      controller: ($scope, $state, $uibModalInstance, $validation) => {
        "ngInject";
        $scope.emails = '';
        $validation.setExpression({
          multiemail: /^$|^(([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\,(\s)?)?)+$/
        }).setDefaultMsg({
          multiemail: {
            error: "No es un correo o listado de correos válido"
          }
        })
        $scope.closeThisDialog = () => $uibModalInstance.close();
        $scope.inviteUser = () => {
          that.subscriptions.push(
            that.service.inviteUser($scope.emails).subscribe(
              (resp) => {
                that.notify.success('Usuario invitado exitosamente.!');
                $scope.closeThisDialog();
              },
              (error) => {
                that.notify.warning('Es posible que alguna de las invitaciones hayan sido enviadas');
              }
            )
          );
        };
      }
    });
  }


  openModalProfiles(){
    var that = this;
    this.modal.open({
      animation: true,
      size: 'lg',
      templateUrl: 'account-profiles-template.html',
      appendClassName: 'ngdialog-theme-plain',
      controller: ($scope, $uibModalInstance) => {
        "ngInject";

        $scope.accountProfiles = [];
        that.subscriptions.push(
          that.service.getAccountProfiles().subscribe(
              (profiles) => $scope.accountProfiles = profiles.map(profile => {
                profile.name = profile.name || '-';
                profile.email = profile.email || '-';
                return profile;
              }),
              (error) => $scope.accountProfiles = []
          )
        );
        $scope.closeThisDialog = () => $uibModalInstance.close();
      }
    });
  }

  useProfile(accountId) {
    const _ = this.trans.instant;
    this.subscriptions.push(
      this.LoginService.getAccountToken(accountId).subscribe(
        (accToken) => {
          if (!accToken) {
            this.notify.error(_("Ha ocurrido un durante el cambio de perfil, intente nuevamente"));
            return;
          }
          this.AuthService.saveAccountToken(accToken);
          this.permissionsService.setProfile(this.profiles.find((p) => p.account_id === accountId));

          let role = this.AuthService.getAccountRole();
          if (role == 'ADMIN' || role == 'MASTER'){
            this.state.go('userControl');
          } else {
            this.state.reload();
          }
        }
      )
    );
  }

  acceptInvitation(invitation, idx){
    this.subscriptions.push(
      this.service.acceptInvitation({invitation: invitation}).subscribe(
        resp => {this.invitationsPending.splice(idx, 1); this.notify.success("Invitación aceptada de manera exitosa."); this.state.reload();},
        resp => {}
      )
    );
  }

  changeLanguage(language){
    if (language != this.userLanguage){
      this.trans.use(language.toLowerCase());
      this.am.changeLocale(language.toLowerCase());      
      this.subscriptions.push(
        this.service.chooseLanguage(language).subscribe(
          (user) => {
            this.$window.localStorage.userLanguage = user.language;
            this.userLanguage = user.language;
          }
        )
      );
    }
  }
}

menuController.$inject = ['$state', 'AuthService', '$window', 'LoginService', '$uibModal', 'ContentService', 'Notification', 'moment', '$validation', 'ProfilePermissionsService', '$translate', 'amMoment', 'SubscriptionService', 'AccountInformationService'];


// WEBPACK FOOTER //
// ./src/app/components/menu/menu.controller.js